/* 太史慈傳・第 1 章：洛陽（186 年前後）
 * 洛陽城在西半邊，東、西各一座城門；城北是宮牆，宮牆南面正中是公車門（上章的人在門外候通）。
 * 東邊是從東萊來的大路：大路往北繞過邙山的岩丘，林子裡另有一條小徑比較近。 */
export const CITY = { x: 3000, y: 2600, hw: 1700, hh: 1300 }, GATE_Y = 2800;
const T = 34, G = 130, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const PALACE = { x: 3000, y: 1750, hw: 700, hh: 300 };
const PN = PALACE.y - PALACE.hh, PS = PALACE.y + PALACE.hh, PW = PALACE.x - PALACE.hw, PE = PALACE.x + PALACE.hw;
export const GONGCHE = [PALACE.x, PS], CLERK = [3150, 2260], CART = [3330, 2300], EGATE = [E, GATE_Y], START = [8150, 2800], GUARDHOUSE = [1850, 2350];
// 州吏的車走的大路（繞邙山）：從城外到公車門
export const MAIN = [START, [7400, 2150], [6600, 1350], [5600, 1500], [5100, 2400], EGATE, [3800, 2800], [3300, 2450], CLERK];
export const SHORT = [[7600, 2950], [6600, 3500], [5400, 3300], EGATE];
const vwall = (x: number, gap: number) => [[x, (N + gap - G) / 2, T, (gap - G - N) / 2], [x, (S + gap + G) / 2, T, (S - gap - G) / 2]];
export default {
  id: 'taishici_luoyang', name: '洛陽', W: 8400, H: 4800, seed: 186,
  bases: [START, [CITY.x, CITY.y]],
  walls: [
    [CITY.x, N, CITY.hw + T, T], [CITY.x, S, CITY.hw + T, T], ...vwall(Wx, GATE_Y), ...vwall(E, GATE_Y),
    [PALACE.x, PN, PALACE.hw + T, T], [PW, PALACE.y, T, PALACE.hh], [PE, PALACE.y, T, PALACE.hh],
    [(PW + GONGCHE[0] - 120) / 2, PS, (GONGCHE[0] - 120 - PW) / 2 + T, T], [(GONGCHE[0] + 120 + PE) / 2, PS, (PE - GONGCHE[0] - 120) / 2 + T, T],
  ],
  roads: [
    { pts: MAIN.slice(0, 6), w: 150 },
    { pts: [EGATE, [3800, 2800], [3300, 2450], [GONGCHE[0], GONGCHE[1] + 160]], w: 150 }, // 城裡：東門到公車門
    { pts: [[Wx, GATE_Y], [2200, 2800], [3300, 2450]], w: 120 },
    { pts: [[3000, 2350], GUARDHOUSE], w: 100 }, // 衛士的廬舍
    { pts: [START, ...SHORT], w: 70 }, // 林中小徑
  ],
  rocks: [[6400, 2400, 520, 260], [6900, 3000, 260, 140], [5900, 900, 380, 180], [7600, 4100, 380, 180], [600, 1200, 320, 160]],
  woods: 0.5,
  sight: 0.85,
  clearings: [[CITY.x, CITY.y + 200, 1500], [PALACE.x, PALACE.y, 700], [EGATE[0], EGATE[1], 300], [START[0], START[1], 300]],
  villages: [{ x: 2100, y: 3350, n: 6, r: 380 }, { x: 4000, y: 3450, n: 5, r: 320 }, { x: 4100, y: 1850, n: 4, r: 260 }, { x: 1900, y: 1850, n: 3, r: 200 }],
  tents: [{ x: GUARDHOUSE[0], y: GUARDHOUSE[1] - 80, n: 2, r: 120, col: '#7a2a22', flag: '衛' }],
  palette: { road: '#9a8a6a', roadEdge: '#7f6f52' },
};
